import styled from 'styled-components';
import {
  Checkbox as SemanticCheckbox,
  Input as SemanticInput,
} from 'semantic-ui-react';
import { themeBalham, iconSetMaterial } from 'ag-grid-community';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;

  .ag-column-first {
    width: 32px;
  }
`;

export const SideMenu = styled.div`
  background-color: white;
  right: 45px;
  border: 1px solid #bdc3c7;
  border-left: 0;
  height: 70vh;
`;

export const MenuItem = styled.div`
  width:40px;
  padding: 5px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
`;

export const MenuTextContainer = styled(TextLayoutComponent)`
  cursor: pointer;
  font-weight: 600;
  font-size: 12px;
`;

export const TableContainer = styled.div`
  width: 100%;
  height: 70vh;
`;

export const MenuTab = styled.div`
  width: 250px;
  display: flex;
  flex-direction: column;
  border: 1px solid #bdc3c7;
  height: 70vh;
  border-left: 0;
`;

export const Checkbox = styled(SemanticCheckbox)`
  &.ui.checkbox {
    margin: 2px 0;
    label {
      color: ${(props) => props.theme.color.textLabel};
      margin-right: 10px;
    }
    input:focus~label {
      color: ${(props) => props.theme.color.textLabel};
    }
  }
`;

export const TabHeader = styled.div`
  border-bottom: 2px solid ${(props) => props.theme.color.textLabel};
  width: 100%;
  padding: 7px;
  display: flex;
  align-items: center;
`;

export const TextTabHeader = styled(TextLayoutComponent)`
  font-weight: 600;
  color: ${(props) => props.theme.color.textLabel};
  font-size: 12px;
  padding-left: 10px;
`;

export const ContainerCheckbox = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)``;

export const Label = styled(TextLayoutComponent)``;

export const ContainerFilters = styled.div`
  padding: 5px 0;
`;

export const Input = styled(SemanticInput)``;

export const GridTheme = themeBalham
  .withParams({
    foregroundColor: 'rgb(0, 0, 0)',
    rowHoverColor: 'rgb(161, 161, 161)',
    headerTextColor: '#4D5473',
    headerBackgroundColor: 'transparent',
    headerColumnBorderHeight: '100%',
    headerRowBorder: { width: 2, color: '#4D5473' },
    columnBorder: { color: '#BDC3C7' },
    rowBorder: { color: '#BDC3C7' },
    wrapperBorderRadius: 0,
  })
  .withPart(iconSetMaterial);
